module.exports = __webpack_public_path__ + "img/home__5fhn——zh.190c386c.png";